'use client'

import { Typography } from '@mui/material'
import { Trans } from 'react-i18next'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const DescriptionTypographyAtom = (props: TypographyProps) => {
	// Props
	const { lng, text } = props

	// Varaibles
	const { t } = useTranslation(lng)

	return (
		<Typography
			component="p"
			fontSize={{ xs: 16, md: 30 }}
			fontWeight={600}
			lineHeight={1.75}
			textAlign="center"
			sx={{
				'& strong': {
					display: 'block',
					fontSize: { xs: 20, md: 40 },
					color: 'primary.main'
				}
			}}
		>
			<Trans t={t} i18nKey={text} />
		</Typography>
	)
}

export default DescriptionTypographyAtom
